import {
  enabled,
  hidden,
  type ActionAvailability,
} from 'modules/common/entityActions';
import {
  useViewerAccess,
  VIEWER_ACCOUNTS,
  type ViewerAccess,
} from 'modules/common/viewer/hostContracts/access';

export const DXF_MAPPING_PART_VIEWER_REASON =
  'Mapping is a quoting tool; this is a Part Viewer account';

/**
 * Whether this user may see mappings at all. The backend refuses every mapping
 * endpoint to a Part Viewer account, so nothing about a mapping is shown,
 * fetched or offered. Takes only the host contract, so the panel and the fetch
 * can ask the same rule as the actions without a mapping subject.
 */
export const getDxfMappingViewAvailability = (
  access: ViewerAccess,
): ActionAvailability =>
  access.account === VIEWER_ACCOUNTS.PART_VIEWER
    ? hidden(DXF_MAPPING_PART_VIEWER_REASON)
    : enabled();

/** Whether the current viewer may see mappings; see `getDxfMappingViewAvailability`. */
export const useCanViewDxfMapping = (): boolean => {
  const access = useViewerAccess();
  return getDxfMappingViewAvailability(access).status === 'enabled';
};
